import React, { Component } from 'react';
import FormHeader from './FormHeader';
import FormFields from './FormFields';

class Form extends Component {
    render() {
        return (
            <div id="form" className={"form" + (this.props.collapse ? " collapse" : "") + (this.props.arrowClass ? " " + this.props.arrowClass : "")}>
                <div className="form-container">
                    <FormHeader {...this.props} />
                    <FormFields {...this.props} />
                </div>
            </div>
        );
    }
}

Form.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default Form;


// WEBPACK FOOTER //
// ./src/components/Form.js